import axios from "axios";
import { atom } from "jotai";
import { SetStateAction } from "jotai/core/types";
import { atomFamily } from "jotai/utils";

import { getTotalSweepEntries } from "../shared/utils";

import {
  LanderCplQuizQuestion,
  LanderCplQuizQuestions,
} from "./lander-cpl-quiz.types";
import { skipLanderCplQuiz } from "./utils";

export const landerCplQuizAtom = atom<
  LanderCplQuizQuestions,
  SetStateAction<LanderCplQuizQuestions>
>(
  async () => {
    try {
      const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
      const params = {
        uid: window.theme.Utils.getCookie("seerid") || "",
        email: submission?.data.email,
      };
      const sweepFormUrl =
        document
          .querySelector("#FormSweepstake")
          ?.getAttribute("data-form-path-url") ?? "";

      const {
        data,
      }: {
        data: LanderCplQuizQuestions;
      } = await axios.get(
        `${window.FKL.yentaServicesApiUrl}/quiz/cpl-lander${sweepFormUrl}`,
        { params }
      );

      if (!data || (data.questions && data.number_of_cosponsors === 0)) {
        await skipLanderCplQuiz();
      }

      return {
        ...data,
        prevExtraEntries: Number(submission?.data.quizExtraEntries) || 0,
        allTimePoints: getTotalSweepEntries(submission?.data) || 0,
      } as LanderCplQuizQuestions;
    } catch (error) {
      if (error.response?.status === 400) {
        await skipLanderCplQuiz();
      }
      throw new Error(error.response?.data?.message ?? error.message);
    }
  },
  (get, set, update) => {
    const newValue =
      typeof update === "function" ? update(get(landerCplQuizAtom)) : update;
    set(landerCplQuizAtom, newValue);
  }
);

export const landerCplQuizQuestionIndexAtom = atom<number>(0);

export const landerCplQuizQuestionAtom = atomFamily<
  number,
  LanderCplQuizQuestion,
  SetStateAction<LanderCplQuizQuestion>
>((questionIndex) =>
  atom(
    (get) => {
      const question = get(landerCplQuizAtom).questions[questionIndex];

      if (!question) {
        throw new Error(`Question id: ${questionIndex} does not exist`);
      }

      return question;
    },
    (_get, set, update) => {
      set(landerCplQuizAtom, (quiz) => ({
        ...quiz,
        questions: quiz.questions.map((question, index) =>
          index !== questionIndex
            ? question
            : typeof update === "function"
            ? update(question)
            : update
        ),
      }));
    }
  )
);

export const landerCplQuizGrantedEntriesAtom = atom<number>(0);
